import { render } from "./Payload.vue?vue&type=template&id=06ed2cea"
import script from "./Payload.vue?vue&type=script&lang=js"
export * from "./Payload.vue?vue&type=script&lang=js"

import "./Payload.vue?vue&type=style&index=0&id=06ed2cea&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__